import React, { useState } from 'react'
import { useConfig } from '@peracto/peracto-config'

import { Link, Redirect } from 'react-router-dom'
import axios from 'axios'

import { LoginFormContainer } from './styled'

const SetPasswordForm = ({ ...props }) => {
    const config = useConfig()
    const API_URL = config.get('api')

    const query = new URLSearchParams(props.location.search)
    const token = query.get('verify')

    const [message, setMessage] = useState('')
    const [isSet, setIsSet] = useState(false)
    const [formData, setFormData] = useState({
        email: '',
        token: token,
        newPassword: '',
        newPasswordVerify: '',
    })
    const [formErrors, setFormErrors] = useState({})

    const onSubmitNewPassword = e => {
        e.preventDefault()
        dispatch('users/update-password', { ...formData })
    }

    const onUpdateFields = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const dispatch = async (url, data) => {
        setFormErrors({})
        try {
            if (formData.newPassword !== formData.newPasswordVerify) {
                setFormErrors({
                    ...formErrors,
                    passwordMatches: 'Passwords must match.',
                })
                return
            } else {
                const response = await axios.post(`${API_URL}/${url}`, data)

                if (response.data.violations !== undefined) {
                    let errors = {}
                    response.data.violations.map(({ propertyPath, message }) => {
                        errors[propertyPath] = message
                    })

                    setFormErrors(errors)
                    return
                }

                setMessage(response.data.message || 'Success! You can now login to your account.')
                setIsSet(true)
            }
        } catch (e) {
            console.log('Error', e)

            if (e?.response?.data?.violations?.length > 0) {
                // Display errors for invalid fields

                const errorMessages = {}
                e.response.data.violations.forEach(error => {
                    errorMessages[error.propertyPath] = error.message
                })

                setFormErrors(errorMessages)
            }

            if (e?.response?.data?.message && e?.status !== '400') {
                setMessage(e.response.data.message)
            }
        }
    }

    if (!token) {
        return <Redirect to="/login" />
    }

    return (
        <LoginFormContainer {...props}>
            <div>
                {!isSet ? (
                    <>
                        <h1 className="!mb-6">Set your password</h1>
                        {message !== '' && <p className="alert alert-info">{message}</p>}
                        {formErrors.token && (
                            <p className="alert alert-danger">{formErrors.token}</p>
                        )}
                        <form
                            onSubmit={onSubmitNewPassword}
                            style={{
                                maxWidth: '330px',
                            }}
                        >
                            <div className="form-group">
                                <input
                                    className="form-control test-focus"
                                    onChange={onUpdateFields}
                                    placeholder="Email"
                                    type="text"
                                    name="email"
                                    data-testid="email"
                                />
                                {formErrors.email && (
                                    <p className="alert alert-danger !mt-1">{formErrors.email}</p>
                                )}
                            </div>
                            <div className="form-group">
                                <input
                                    className="form-control test-focus"
                                    onChange={onUpdateFields}
                                    placeholder="New Password"
                                    type="password"
                                    name="newPassword"
                                    autoComplete="off"
                                    data-testid="new-password"
                                />
                                {formErrors.newPassword && (
                                    <p className="alert alert-danger !mt-2">
                                        {formErrors.newPassword}
                                    </p>
                                )}
                            </div>
                            <div className="form-group">
                                <input
                                    className="form-control test-focus"
                                    onChange={onUpdateFields}
                                    placeholder="Verify Password"
                                    type="password"
                                    name="newPasswordVerify"
                                    autoComplete="off"
                                    data-testid="verify-password"
                                />
                                {formErrors.newPasswordVerify && (
                                    <p className="alert alert-danger">
                                        {formErrors.newPasswordVerify}
                                    </p>
                                )}
                            </div>

                            {formErrors.passwordMatches && (
                                <p className="alert alert-danger">{formErrors.passwordMatches}</p>
                            )}

                            <div className="!flex !justify-between !items-center">
                                <button
                                    className="btn btn-primary "
                                    disabled={!formData.newPassword || !formData.newPasswordVerify}
                                    data-testid="reset"
                                >
                                    Reset
                                </button>
                            </div>
                        </form>
                    </>
                ) : (
                    <>
                        <p className="alert alert-info">{message}</p>
                        <div className="!flex !justify-between !items-center !mt-2">
                            <Link to="/login" className="btn btn-primary" data-testid="sign-in">
                                Login
                            </Link>
                        </div>
                    </>
                )}
            </div>
        </LoginFormContainer>
    )
}

export default SetPasswordForm
